const CACHE_SEARCH_PARAMS = Object.freeze({
    ignoreMethod: true,
    ignoreSearch: true,
});

const _openCache = (name: string): Promise<Cache> =>
    /* Caches not always available on every browser. *MUST* check */
    /* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */
    caches === undefined ? Promise.reject(new Error('No caches available')) : caches.open(name);

const _insertToCache = (cache: Cache, request: Request, response: Response): Promise<void> =>
    cache.put(request, response);

const _isInCache = async (cache: Cache, request: Request): Promise<boolean> => {
    const result = await caches.match(request, CACHE_SEARCH_PARAMS).catch(() => undefined);
    return Boolean(result);
};

export default Object.freeze({
    open: _openCache,
    insert: _insertToCache,
    exists: _isInCache,
});
